import { Fragment } from 'react';
import PropTypes from 'prop-types';

import './BookDetails.less';
import { mapBinding } from '../../utils/book/bindingHelper';
import { getAuthors } from '../../utils/book';

/**
 * If image-url is retrieved from /api/book/?isbn=<isbn>,
 * will the format be image_url instead of the better convention: imageUrl
 * */
const getImageUrl = (book) => book.imageUrl || book.image_url;

const getPublishedYear = (book) => book.publishedYear || book.published_year;

const BookDetails = ({ book, buttonLabel = null }) => {
  const imageUrl = getImageUrl(book);

  return <div className="bookdetails">
    <div className="bookdetails__cover">
      <img src={imageUrl} alt={book.title}/>
    </div>
    <div className="bookdetails__metadata">
      <h4>{book.title} <em>({book.edition || 0}. utgave)</em></h4>

      <dl className="bookdetails__metadata__info">
        {(book.authors.length > 0) && <Fragment>
          <dt>Av</dt>
          <dd>{getAuthors(book).join(', ')}</dd>
        </Fragment>}

        {book.publisher && <Fragment>
          <dt>Forlag</dt>
          <dd>{book.publisher}</dd>
        </Fragment>}

        <dt>ISBN</dt>
        <dd>{book.isbn}</dd>

        <dt>Utgitt</dt>
        <dd>{getPublishedYear(book)}, {mapBinding(book.binding)}</dd>
      </dl>

      {buttonLabel && <button className="button button-flat">
        {buttonLabel}
      </button>}
    </div>
  </div>;
};

BookDetails.propTypes = {
  book: PropTypes.shape({
    title: PropTypes.string.isRequired,
    isbn: PropTypes.string.isRequired,
    image: PropTypes.string,
    image_url: PropTypes.string,
  }).isRequired,
  buttonLabel: PropTypes.string,
};

export default BookDetails;
